import { Observable, Subject } from 'rxjs';
import { environment } from './../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class PublicReportService {
  breadCrumbArr = [];
  headerTextLbl = 'State';
  filterParams: any = {};
  public districtname = new Subject<any>();
  public ischeckSessionStarted = new Subject<any>();
  public isnational = new Subject<any>();
  public district_id = new Subject<any>();
  public type = new Subject<any>();
  public statename = new Subject<any>();
  public tabname = new Subject<any>();
  constructor(private http: HttpClient) { }


  getPublicReports(stateid = "", districtid = "", date = ""): Observable<any> {
    return this.http.get<any>(
      `${environment.report_prefix_direct_url}/v2/getPublicReports?state_id=${stateid}&district_id=${districtid}&date=${date}`
    );
  }

  //registration Dashboard data
  getRegistrationDashboardData(date = ""): Observable<any> {
    //return this.http.get("/assets/json/regReport.json");https://api.sit.co-vin.in/api/v1/reports/getAllRegReports
    return this.http.get<any>(
      `${environment.report_prefix_direct_url}/getAllRegReports`
    );
  }

  //Vaccination Dashboard data
  getVaccinationDashboardData(stateid = "", districtid = "", date = ""): Observable<any> {
    //return this.http.get("/assets/json/vaccDashboard.json");
    return this.http.get<any>(
      `${environment.report_prefix_direct_url}/v2/getVacPublicReports?state_id=${stateid}&district_id=${districtid}&date=${date}`
    );
  }


  dashboardLogin(): Observable<any> {
    return this.http.post(
      `${environment.auth_prefix_url}/guest/dashboard_login`,
      {},
      { responseType: 'text' }
    );
  }

  getNewDashboardData(): Observable<any> {
    return this.http.get("/assets/json/dashboard.json");
  }

  getDistricts(): Observable<any> {
    return this.http.get("/assets/json/csvjson.json");
  }

  getDistrictname(): Observable<any> {
    return this.districtname.asObservable();
  }

  getSessionStatus(): Observable<any> {
    return this.ischeckSessionStarted.asObservable();
  }

  getNationalStatus(): Observable<any> {
    return this.isnational.asObservable();
  }
  getDistrictID(): Observable<any> {
    return this.district_id.asObservable();
  }

  getType(): Observable<any> {
    return this.type.asObservable();
  }
  getStatename(): Observable<any> {
    return this.statename.asObservable();
  }

  getTabname(): Observable<any> {
    return this.tabname.asObservable();
  }

  
  getVacPublicReports(stateid = "", districtid = "", date = ""): Observable<any> {
    return this.http.get<any>(
      `${environment.report_prefix_direct_url}/v2/getVacPublicReports?state_id=${stateid}&district_id=${districtid}&date=${date}`
    );
  }

  getLiveVaccinationCounter(): Observable<any> {
    return this.http.get(`https://cdn-api.co-vin.in/api/v1/reports/getLiveVaccination`)
  }

  
  getLiveVaccinationCounterChart(date): Observable<any> {
    return this.http.get(`https://prod-cdn.preprod.co-vin.in/vaccination_live_counter/PROD/${date}.json`)
  }
}
